<template>
  <div>
    <div class="my_nav" :class="{ fixed: isFixed }">
      <div id="bigBox" class="menu_box">
        <div class="nav_left">
          <img src="../assets/img/navLogo.png" alt="" />
        </div>
        <div class="nav_center">
          <ul class="nav_menu">
            <template v-for="item in navConfig.menuData">
              <li
                class="nav_menu_item"
                :id="pagePath == item.path ? 'activePage' : ''"
                :key="item.id"
                @click="$utils.goPage(item.path)"
              >
                {{ item.title }}
              </li>
            </template>
          </ul>
        </div>
        <div class="nav_right">
          <div class="user_info_box" v-if="userInfo != null">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="user_info">
                <div
                  v-if="userInfo.avatar == '' || userInfo.avatar == null"
                  class="def_avatar"
                >
                  {{
                    userInfo.realname == userInfo.phone
                      ? userInfo.phone.substring(0, 3)
                      : userInfo.realname.charAt(0)
                  }}
                </div>
                <img
                  v-else
                  :src="$utils.formatImgUrl(userInfo.avatar)"
                  alt=""
                />
                <p>{{ userInfo.realname }}</p>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">完善信息</el-dropdown-item>
                <el-dropdown-item command="2">编辑信息</el-dropdown-item>
                <el-dropdown-item command="3">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <ul class="login_reg" v-else>
            <li class="theme_color" @click="goPage('/login', '登录')">登录</li>
            <li @click="goPage('/login', '注册')">注册</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 完善信息   编辑信息 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFlag"
      :close-on-press-escape="false"
      :show-close="false"
      :open="getUserInfo"
      width="40%"
      center
    >
      <el-form
        label-position="right"
        label-width="80px"
        :model="formData"
        :rules="rules"
        ref="formForm"
      >
        <el-form-item label="头像">
          <el-upload
            class="avatar-uploader"
            :action="$baseUrl + 'api/sys/common/upload'"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :data="{ biz: 'avatar' }"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="名称" prop="realname">
          <el-input v-model="formData.realname"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="formData.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" prop="entName">
          <el-input v-model="formData.entName"></el-input>
        </el-form-item>
        <el-form-item label="企业规模" prop="entScale">
          <el-select v-model="formData.entScale" placeholder="请选择企业规模">
            <el-option label="5000万-1亿" value="5000万-1亿"></el-option>
            <el-option label="1亿-3亿" value="1亿-3亿"></el-option>
            <el-option label="3亿-5亿" value="3亿-5亿"></el-option>
            <el-option label="5亿-10亿" value="5亿-10亿"></el-option>
            <el-option label="10亿以上" value="10亿以上"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFlag = false">取消</el-button>
        <el-button type="primary" @click="submitForm('formForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateUserInfoApi } from "@/apis/index.js";
export default {
  props: {
    companyConfig: {
      type: Object,
      default: () => {},
    },
  },
  name: "MyNav",
  data() {
    return {
      navConfig: {
        logo: "",
        textColor: "",
        activeTextColor: "",
        menuData: [
          { id: "1", title: "首页", path: "/", children: [] },
          { id: "2", title: "企业AI方案", path: "/business", children: [] },
          { id: "3", title: "课程师资", path: "/teacher", children: [] },
          { id: "4", title: "产品介绍", path: "/product", children: [] },
          { id: "5", title: "关于我们", path: "/about/conpany", children: [] },
        ],
      },
      pagePath: "",
      isFixed: false,
      userInfo: null,
      headers: {},
      dialogTitle: "完善信息",
      dialogFlag: false,
      formData: {
        avatar: "",
        realname: "",
        phone: "",
        email: "",
        entName: "",
        entScale: "10亿以上",
      },
      rules: {
        realname: [{ required: true, message: "请输入名称", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
        entName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        entScale: [
          { required: true, message: "请选择企业规模", trigger: "change" },
        ],
      },
      imageUrl: "", // 空图片显示上传按钮
    };
  },
  watch: {
    "$route.path": {
      handler(newVal) {
        this.pagePath = newVal;
        // 路由变化时更新用户信息
        this.getUserInfo();
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getUserInfo();
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.formData.avatar = file.response.message;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 获取用户信息
    getUserInfo() {
      if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.formData.realname = this.userInfo.realname || "";
        this.formData.phone = this.userInfo.phone || "";
        this.formData.email = this.userInfo.email || "";
        this.formData.entName = this.userInfo.entName || "";
        this.formData.entScale = this.userInfo.entScale || "";
        if (this.userInfo.avatar != "" || this.userInfo.avatar != null) {
          this.imageUrl = this.$utils.formatImgUrl(this.userInfo.avatar);
        }
      } else {
        this.userInfo = null;
      }

      if (localStorage.getItem("token")) {
        this.headers["x-access-token"] = localStorage.getItem("token");
        // 或者
        this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      }
    },
    handleCommand(val) {
      if (val == 3) {
        localStorage.clear();
        this.userInfo = null;
        return;
      } else if (val == "1") {
        this.getUserInfo();
        this.dialogTitle = "完善信息";
      } else if (val == "2") {
        this.getUserInfo();
        this.dialogTitle = "编辑信息";
      }
      this.dialogFlag = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let data = await updateUserInfoApi(this.formData);
          if (data.code == 200) {
            console.log(data);
            this.$message({
              message: "更新成功",
              type: "success",
            });
            this.dialogFlag = false;
            localStorage.setItem("userInfo", JSON.stringify(data.result));
            this.getUserInfo();
          } else {
            this.$message({
              message: data.message,
              type: "error",
            });
          }
        }
      });
    },
    goPage(val, text) {
      if (this.$route.path == val) {
        return;
      }
      this.$router.push({
        path: val,
        query: {
          pageText: text,
        },
      });
    },
    handleScroll() {
      const scrollTop = window.scrollY;
      this.isFixed = scrollTop > 100;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped lang="less">
.my_nav {
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  z-index: 999;
  height: 6.25rem;

  &.fixed {
    position: fixed;
  }

  .menu_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 8%;
    box-sizing: border-box;

    .nav_left {
      display: flex;
      height: 100%;
      align-items: center;
      > img {
        width: 150px;
      }
    }

    .nav_center {
      width: 40%;
      display: flex;
      align-items: center;
      height: 100%;
      .nav_menu {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        min-width: 450px;

        > .nav_menu_item {
          height: 99%;
          line-height: 6.25rem;
          font-weight: 300;
          color: #fff;
          position: relative;
          font-size: 0.875rem;
        }

        > .nav_menu_item:hover {
          color: #00aff2;
        }
      }
    }

    .nav_right {
      width: 20%;
      min-width: 200px;

      .login_reg {
        display: flex;
        justify-content: flex-end;

        > li {
          font-weight: 400;
          color: #000;
          padding: 0.375rem 12%;
          border-radius: 20px;
          letter-spacing: 2px;
          font-size: 0.875rem;
        }
        > li:first-child {
          color: #fff;
        }
        > li:last-child {
          color: #00aff2;
          border: 1px solid #00aff2;
          margin-left: 20px;
        }
      }
    }
  }
}

#activePage {
  font-weight: bold;
  color: #00aff2;
}
.user_info {
  display: flex;
  align-items: center;
  > img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    margin-right: 0.625rem;
  }
  > p {
    font-weight: 300;
    color: #fff;
    position: relative;
    font-size: 0.875rem;
  }
  .def_avatar {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    background: #00aff2;
    color: #fff;
    font-size: 1rem;
    text-align: center;
    line-height: 2.5rem;
    margin-right: 0.625rem;
  }
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 4.375rem;
  height: 4.375rem;
  line-height: 4.375rem;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 1.25rem;
  color: #8c939d;
  text-align: center;
}
.avatar {
  width: 4.375rem;
  height: 4.375rem;
  display: block;
}
</style>
